<template>
  <div class="">
    <!-- <Debug -->
    <!-- label="map" -->
    <!-- :data="map" -->
    <!-- /> -->

    <section class="submenu tw-bg-gradient2-lr tw-py-4">
      <div class="container tw-flex tw-justify-between tw-items-center">
        <div class="tw-flex tw-text-white">
          <button
            class="tw-ml-1 btn-circle btn-circle-md btn-circle-submenu-map tw-flex-shrink-0 world-map home-button"
            @click="goHome"
          >
            <i
              class="far fa-dot-circle"
              aria-hidden="true"
            />
          </button>
          <button
            class="desktop tw-ml-1 btn-circle btn-circle-md btn-circle-submenu-map tw-flex-shrink-0 world-map world-button"
            @click="worldMap"
          >
            <i
              class="fas fa-globe-americas"
              aria-hidden="true"
            />
          </button>
          <button
            v-if="options.mode === 'user'"
            class="tw-ml-1 btn-circle btn-circle-md btn-circle-submenu-map tw-flex-shrink-0 world-map filters-button"
            @click="toggleFilters"
          >
            <i
              class="fas fa-filter"
              aria-hidden="true"
            />
          </button>
          <button
            class="tw-ml-1 btn-circle btn-circle-md btn-circle-submenu-map tw-flex-shrink-0 world-map help-button"
            @click="toggleHelp"
          >
            <i
              class="far fa-question-circle"
              aria-hidden="true"
            />
          </button>
        </div>
        <div class="map-options">
          <MultiSelect
            key="value"
            v-model="selectedPlace"
            :options="placesForMultiSelectField"
            :close-on-select="true"
            selected-label=""
            select-label=""
            deselect-label=""
            placeholder="Zoom to a city"
            label="location"
            track-by="value"
            @select="zoomToPlace"
          >
            <template
              slot="option"
              slot-scope="props"
            >
              <!-- <a href="#" class="flex items-center px-4 py-2 text-sm leading-5 text-gray-700 group hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"> -->
              <!-- <svg class="w-5 h-5 mr-3 text-gray-400 group-hover:text-gray-500 group-focus:text-gray-500" fill="currentColor" viewBox="0 0 20 20"> -->
              <!-- <path d="M17.414 2.586a2 2 0 00-2.828 0L7 10.172V13h2.828l7.586-7.586a2 2 0 000-2.828z"/> -->
              <!-- <path fill-rule="evenodd" d="M2 6a2 2 0 012-2h4a1 1 0 010 2H4v10h10v-4a1 1 0 112 0v4a2 2 0 01-2 2H4a2 2 0 01-2-2V6z" clip-rule="evenodd"/> -->
              <!-- </svg> -->
              <!-- Edit -->
              <!-- </a>             -->
              <div class="tw-flex tw-items-center">
                <div
                  class="option__count"
                  :style="{'background-image': 'url(' + require('@/assets/img/content/map/markers/heart-icon-small.png') + ')'}"
                >
                  <span>{{ props.option.count }}</span>
                </div>
                <div class="option__namex tw-flex-grow-1">
                  {{ props.option.location }}
                </div>
              </div>
            </template>
          </MultiSelect>
        </div>
      </div>
    </section>

    <Modal name="map-filter">
      <div class="modal-header">
        <h4 class="modal-title">
          Map Filters
        </h4>
      </div>
      <div
        class="modal-body row"
        style="min-height:300px;"
      >
        <!-- <MapFilter /> -->
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="tw-flex-shrink-0 btn btn-lg btn-gradient-lr"
          @click="hideFilters"
        >
          Hide
        </button>
      </div>
    </Modal>

    <section class="map">
      <div id="soulmap">
        <GmapMap
          v-if="mapMarkers.length > 0"
          ref="map"
          :center="map.center"
          :zoom="map.zoom"
          :options="mapOptions"
          style="margin: 0 auto; width: 100%; height: 600px"
          @zoom_changed="zoomChanged"
        >
          <GmapCluster
            v-if="showClusters"
            :max-zoom="12"
            :grid-size="gridSize"
            :styles="clusterstyles"
          >
            <!-- <GmapCluster :max-zoom="12" :grid-size="gridSize"> -->
            <GmapMarker
              v-for="(mapMarker, index) in mapMarkers"
              :key="index"
              :position="{ lat: mapMarker.location.lat, lng: mapMarker.location.lng }"
              :clickable="true"
              :draggable="false"
              :icon="getMarkerIcon(mapMarker)"
              :options="{
                optimized: false,
              }"
              @click="toggleInfoWindow(mapMarker, mapMarker.id)"
            />
          </GmapCluster>

          <GmapInfoWindow
            :opened="infoWindow.open"
            :position="infoWindow.position"
            :options="infoWindow.options"
            @closeclick="closeInfoWindow()"
          >
            <div v-html="infoWindow.content" />
          </GmapInfoWindow>
        </GmapMap>
      </div>
    </section>
  </div>
</template>

<script>
/* eslint-disable global-require */

import { sync } from 'vuex-pathify';

import map from '@/mixins/pages/map';
import mapOptions from '@/mixins/pages/map-options';
import mapClusters from '@/mixins/pages/map-clusters';
import mapInfoWindow from '@/mixins/pages/map-info-window';

import MapMarker from '@/vuex/orm/models/MapMarker';

export default {
  components: {
    // MapFilter: () => import('@/components/map/MapFilter'),
    GmapCluster: () => import('vue2-google-maps/dist/components/cluster'),
    MultiSelect: () => import('vue-multiselect'),
  },

  mixins: [
    map, //
    mapOptions, //
    mapClusters, //
    mapInfoWindow, //
  ],

  props: {
    options: {
      type: Object,
      default: () => ({}),
    },
    mapMarkers: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      /* CLUSTERS */
      homeCityId: this.$auth.user().currentLocation.id,
      filtersVisible: false,
      selectedPlace: null,

      places: [],
      placesForMultiSelectField: [],
    };
  },

  computed: {
    ...sync([
      'map', //
    ]),
  },

  watch: {
    places(places) {
      this.placesForMultiSelectField = [];

      places.forEach((place) => {
        this.placesForMultiSelectField.push({
          location: `${place.city}, ${place.country}`,
          count: place.nbUsers,
          value: place.id,
        });
      });
    },
  },

  created() {
    Bus.$emit('loading', true);

    this.loadMapMarkers(true);
  },

  mounted() {
    this.registerMapBusListeners();
  },

  beforeDestroy() {
    Bus.$off('filters:updated');
  },

  methods: {
    registerMapBusListeners() {
      Bus.$on('filters:updated', () => {
        this.reloadMapMarkers();
      });
    },

    toggleHelp() {
      Bus.$emit('shepherd-tour:show', 'map');
    },

    toggleFilters() {
      if (this.filtersVisible) {
        this.hideFilters();
      } else {
        this.showFilters();
      }
    },

    showFilters() {
      this.filtersVisible = true;
      Bus.$emit('modal:toggle', 'map-filter');
    },

    hideFilters() {
      this.filtersVisible = false;
      this.$root.$emit('bv::hide::modal', 'map-filter');
    },

    placeOptionText(place) {
      return `${place.nbUsers} nomads in ${place.city}, ${place.country}`;
    },

    goToLastLocation() {
      // console.log('Map.goToLastLocation');
      this.setZoom(this.map.zoom);
      this.setCenter(this.map.center);
    },

    zoomToPlace(placeRecord) {
      // console.log('Map.zoomToPlace.placeRecord.location', placeRecord.location);

      const place = MapMarker.query()
        .where('location', (location) => location.id === placeRecord.value)
        .first();

      this.setZoom(13);
      this.setCenter({
        lat: place.location.lat,
        lng: place.location.lng,
      });
    },

    reloadMapMarkers() {
      // console.log('Map.reloadMapMarkers');
      this.loadMapMarkers(false);
    },

    loadMapMarkers(initial) {
      // if (initial) this.worldMap();

      this.extractPlacesFromMarkers();

      // this.$http.get(this.options.url).then((response) => {
      // this.profiles = response.data.profiles;
      // this.places = response.data.places;
      // this.zoomToPlace(Object.keys(this.places)[0]);
      Bus.$emit('loading', false);

      if (initial && this.map.center.lat === 10.0 && this.map.center.lng === 10.0) {
        // If current home has other nomads, zoom to there
        // console.log(this.places[this.homeCityId].nbUsers);
        if (typeof this.places[this.homeCityId] !== 'undefined' && this.places[this.homeCityId].nbUsers > 1) {
          setTimeout(() => {
            console.log(`set picker to ${this.homeCityId}`);
            this.goHome();
          }, 3000);
        } else {
          this.goToLastLocation();
        }
      } else {
        this.goToLastLocation();
      }
      // });
    },

    extractPlacesFromMarkers() {
      const places = [];

      // console.log('mapMarkers', this.mapMarkers);

      this.mapMarkers.forEach((mapMarker) => {
        // console.log('mapMarker', mapMarker.location.id);
        if (typeof places[mapMarker.location.id] !== 'undefined') {
          places[mapMarker.location.id].nbUsers += 1;
        } else {
          places[mapMarker.location.id] = {
            id: mapMarker.location.id,
            city: mapMarker.location.city,
            country: mapMarker.location.country,
            lat: mapMarker.location.lat,
            lng: mapMarker.location.lng,
            nbUsers: 1,
          };
        }
      });

      this.places = Object.values(places).sort((a, b) => b.nbUsers - a.nbUsers);

      // console.log('extractPlacesFromMarkers.places', this.places);
      // console.log('extractPlacesFromMarkers.places[0]', this.places[0]);
      // console.log('extractPlacesFromMarkers.places.length', this.places.length);
    },

    toggleInfoWindow(marker, id) {
      this.setCenter({
        lat: marker.location.lat,
        lng: marker.location.lng,
      });

      this.infoWindow.position = { lat: marker.location.lat, lng: marker.location.lng };
      this.infoWindow.content = `
                <div class="mapInfoWindow">
                    <a class='profileLink-${id}'>
                      <img src="${this.$api}${marker.bigThumb}" class="img-responsive">
                    </a>
                    <br>
                    <a class='profileLink-${id}'>
                      ${marker.nickname}
                    </a> is in <br> ${marker.location.city}, ${marker.location.country}
                    <div class="randomLocation">Location within city is randomized</div>
                </div>
                `;

      if (this.infoWindow.id === id) {
        // same -> toggle between visibility
        this.infoWindow.open = !this.infoWindow.open;
        this.infoWindow.id = marker.id;
      } else {
        // not same -> open the new one
        this.infoWindow.open = true;
        this.infoWindow.id = marker.id;
      }

      setTimeout(() => {
        $(`.mapInfoWindow a.profileLink-${id}`).click((event) => {
          const mapMarker = MapMarker.query()
            .where('id', id)
            .first();

          if (event.metaKey || event.ctrlKey) {
            const routeData = this.$router.resolve({ name: 'profile', params: { profile: mapMarker.uuid } });
            window.open(routeData.href, '_blank');
          } else {
            this.$router.push({
              name: 'profile',
              params: { profile: mapMarker.uuid },
            });
          }
        });
      }, 250);
    },
  },
};
</script>

<style>
.btn-circle-submenu-map {
  @apply tw-bg-white tw-text-custom-blue tw-shadow;
}

.btn-circle-submenu-map:hover {
  @apply tw-shadow-lg;
  color: #23527c;
}

.btn-circle-submenu-map:active {
  @apply tw-bg-custom-midgray;
}

.map-options .multiselect {
  @apply tw-w-48 tw-text-xs;
}

@screen sm {
  .map-options .multiselect {
    @apply tw-w-72 tw-text-base;
  }
}

.map-options .multiselect .option__count {
  @apply tw-text-white tw-align-middle tw-text-center tw-mr-2;
  height: 27px;
  width: 30px;
}

.map-options .multiselect .option__count span {
  font-size: 10px;
  position: relative;
  top: 3px;
}
</style>

<style lang="scss">
#soulmap {
  .mapInfoWindow {
    position: relative;
    text-align: left;
    padding: 5px 0 5px 15px;
    font-size: 16px;
    // line-height: 22px;
    a {
      color: #04b9b2;
    }
    img {
      border-radius: 50%;
      border: 5px solid #eee;
      width: 33.33%;
      float: left;
      margin-right: 20px;
    }
    .randomLocation {
      position: absolute;
      right: 0px;
      bottom: -30px;
      color: pink;
      font-size: 10px;
    }
  }
  img[src*='map.jpg'] {
    width: 90%;
    border-radius: 50%;
    border: 1px solid #eee;
  }
}

@media (max-width: 767px) {
  #soulmap .mapInfoWindow {
    font-size: 1.4rem;
    padding: 0;
    line-height: 20px;
    .randomLocation {
      bottom: -3rem;
      font-size: 0.9rem;
    }
  }
}
</style>
